import { render, staticRenderFns } from "./GuestNameDialog.vue?vue&type=template&id=0eec23a0&scoped=true&"
import script from "./GuestNameDialog.vue?vue&type=script&lang=js&"
export * from "./GuestNameDialog.vue?vue&type=script&lang=js&"
import style0 from "./GuestNameDialog.vue?vue&type=style&index=0&id=0eec23a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eec23a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eec23a0')) {
      api.createRecord('0eec23a0', component.options)
    } else {
      api.reload('0eec23a0', component.options)
    }
    module.hot.accept("./GuestNameDialog.vue?vue&type=template&id=0eec23a0&scoped=true&", function () {
      api.rerender('0eec23a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/components/GuestNameDialog.vue"
export default component.exports